import { Component, OnInit } from '@angular/core';
import { EngagmentCountModel } from '../../../models/engagment-count.model';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-activity-count',
  templateUrl: './activity-count.component.html',
  styleUrls: ['./activity-count.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class ActivityCountComponent implements OnInit {
  activityCount!: EngagmentCountModel;
  loading = false;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.loading = true;
    this.osm.getActivitiesCountRequiringAction().subscribe(activityCount => {
      this.activityCount = activityCount;
      this.loading = false;
    });
  }
}
